export const calculationFirstCellPrompt = (subject: string): string =>
  `Explain how ${subject} was calculated, what contributed to it, and any source gaps.`;
